module.exports = __webpack_public_path__ + "static/img/pic2.1f1563c7.jpg";